import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

export default {
  install(app) {
    let files = import.meta.globEager('@/components/base/*.vue');
    registerFiles(app, files);

    files = import.meta.globEager('@/components/icon/*.vue');
    registerFiles(app, files);

    files = import.meta.globEager('@/components/widgets/v1/*.vue');
    registerFiles(app, files, 'V1');

    files = import.meta.globEager('@/components/widgets/v2/*.vue');
    registerFiles(app, files, 'V2');
  }
};

function registerFiles(app, files, version = null) {
  Object.entries(files).forEach(([path, m]) => {
    let componentName = upperFirst(
      camelCase(
        path
          .split('/')
          .pop()
          .replace(/\.\w+$/, '')
      )
    );

    const sharedWidgetComponents = ['WidgetsBaseComponent', 'WidgetsErrorMessage', 'WidgetsContainer'];
    if (version && !sharedWidgetComponents.includes(componentName)) {
      componentName = componentName.replace('Widgets', `Widgets${version}`);
    }

    if (componentName) {
      app.component(componentName, m.default);
    }
  });
}
